import intersectEffects from "./intersectEffects";
export default () => ({
    removeGraphicOut(){
        this.$refs.graphic.classList.remove('out')
    },
    graphicAddAnimate() {
        this.$refs.graphic.classList.add('animate')
    },
    get notMobile(){
        return !this.mobile
    },
    ...intersectEffects()
})